import React, { memo } from 'react'
// import Button from '@material-ui/core/Button'
// import SettingsIcon from '@material-ui/icons/Settings'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import Hidden from '@material-ui/core/Hidden'
import { useTheme } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import classNames from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'

import { useArticleState } from '../../../../reducer'
import styles from './styles'
import { SearchContainer, SelectedTags } from './components'
import { TagsProvider } from './reducer'
import { EArticleActionTypes } from 'models'

const useStyles = makeStyles(styles)

const Tags: React.FunctionComponent<{}> = memo(() => {
	const theme: Theme = useTheme()
	const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))
	const classes = useStyles()
	const { t } = useTranslation()
	const [state, dispatch] = useArticleState()
	
	const { tagging: stateTagging, tags } = state
	const tagging = stateTagging
	const savedTags = tags
	const showTags = () => {
		dispatch({
			type: EArticleActionTypes.seITagging,
			tagging: true,
		})
	}
	const closeTags = () => {
		dispatch({
			type: EArticleActionTypes.seITagging,
			tagging: false,
		})
	}

	return (
		<div
			className={classNames(classes.container, {
				[classes.activeContainer]: isDownSm && tagging,
			})}
			style={{
				height: tagging ? (isDownSm ? '100%' : '50%') : undefined,
				minHeight: tagging ? (isDownSm ? '100%' : '50%') : undefined,
			}}
		>
			{tagging && (
				<Hidden smDown>
					<div className={classes.overlay} onClick={closeTags} />
				</Hidden>
			)}
			{!tagging && (
				<div className={classes.inactiveContainer} onClick={showTags}>
					<div className={classes.placeholder}>
						<IconButton
							className={classes.iconButton}
							aria-label="Search"
						>
							<SearchIcon />
						</IconButton>
						<SelectedTags />
						{
							savedTags.length < 1 &&
								t(
									'People will endorse the post based on tags (add up to 5)',
								)
							// (section === EArticleSectionTypes.post
							// 	? t('choose up to 5 tags for your post')
							// 	: t('choose up to 5 tags for your article'))
						}
					</div>
					{/* <Button
						variant="outlined"
						color="default"
						className={classes.manageTagsContainer}
					>
						<SettingsIcon classes={{ root: classes.iconRoot }} />
						<Hidden smDown>{t('Manage')}</Hidden>
					</Button> */}
				</div>
			)}
			{tagging && (
				<SearchContainer
					placeholder={
						t(
							'choose up to 5 tags (other users will appreciate them)',
						)
						// section === SectionTypes.post
						// 	? t('choose up to 5 tags for your post')
						// 	: t('choose up to 5 tags for your article')
					}
				/>
			)}
		</div>
	)
})

export default (props: any) => {
	return (
		<TagsProvider selected={props.selected}>
			<Tags {...props} />
		</TagsProvider>
	)
}
